<template>
  <div>
    <el-popover
      ref="popover"
      placement="top"
      width="350"
      trigger="hover">
      <image-component :image="image" width="300"></image-component>
    </el-popover>
    <image-component :image="image" :width="imgWidth" v-popover:popover></image-component>
  </div>
</template>

<script>
export default {
  props: {
    image: [Object, String],
    imgWidth: {
      type: Number,
      default: 30,
    },
  }
}
</script>

